module.exports = __webpack_public_path__ + "static/vf_wskirt3_core.9094b577.svg";